import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-full flex-col">
      <header className="mx-auto flex w-full max-w-3xl items-center justify-between px-5 py-5">
        <Link to="/" className="flex items-center gap-2 text-lg font-semibold tracking-tight">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-brand-500/20 text-brand-400">
            ⚡
          </span>
          Beam
        </Link>
        <a
          href="https://developers.cloudflare.com/durable-objects/"
          target="_blank"
          rel="noreferrer"
          className="text-sm text-slate-400 transition hover:text-slate-200"
        >
          peer-to-peer · no uploads
        </a>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 px-5 pb-16">{children}</main>

      <footer className="mx-auto w-full max-w-3xl px-5 py-6 text-center text-xs text-slate-500">
        Files travel directly browser-to-browser over an encrypted WebRTC connection. The server
        only introduces the two peers — it never sees your data.
      </footer>
    </div>
  );
}
